module.exports = __webpack_public_path__ + "static/media/Blue-arrow-right.b4578c78.svg";